import { ActionKeys } from './constants';

export const applyOrReplacePromoCode = (code: string, isReplacement: boolean) =>
  <const>{
    code,
    isReplacement,
    type: ActionKeys.PROMO_CODE_APPLY_OR_REPLACE,
  };

export const applyOrReplacePromoCodeSuccess = () =>
  <const>{
    type: ActionKeys.PROMO_CODE_APPLY_OR_REPLACE_SUCCESS,
  };

export const applyOrReplacePromoCodeError = (error: Error) =>
  <const>{
    error,
    type: ActionKeys.PROMO_CODE_APPLY_OR_REPLACE_ERROR,
  };

export const applyOrReplacePromoCodeSuccessClear = () =>
  <const>{
    type: ActionKeys.PROMO_CODE_APPLY_OR_REPLACE_SUCCESS_CLEAR,
  };

export type PromoActions =
  | ReturnType<typeof applyOrReplacePromoCode>
  | ReturnType<typeof applyOrReplacePromoCodeError>
  | ReturnType<typeof applyOrReplacePromoCodeSuccess>
  | ReturnType<typeof applyOrReplacePromoCodeSuccessClear>;
